import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    { id: 1, label: 'Home', link: 'home' },
    { id: 2, label: 'About', link: 'about' },
    { id: 3, label: 'Projects', link: 'portfolio' },
    { id: 4, label: 'Skills', link: 'experience' },
    { id: 5, label: 'Contact', link: 'contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 z-50 w-full border-b border-white/10 bg-black/80 text-white backdrop-blur-md">
      <div className="max-w-screen-xl mx-auto h-20 px-6 flex items-center justify-between">
        <Link to="home" smooth duration={500} className="cursor-pointer">
          <span className="text-2xl sm:text-3xl font-bold tracking-tight">
            Ajit<span className="text-cyan-400">.</span>
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-8">
          {links.map(({ id, label, link }) => (
            <li key={id}>
              <Link
                to={link}
                smooth
                duration={500}
                offset={-80}
                className="cursor-pointer text-sm font-medium text-gray-400 transition hover:text-white"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <button
          onClick={() => setNav((value) => !value)}
          className="md:hidden text-gray-300"
          aria-label="Toggle navigation"
        >
          {nav ? <FaTimes size={26} /> : <FaBars size={26} />}
        </button>
      </div>

      {nav && (
        <div className="md:hidden border-t border-white/10 bg-black">
          <ul className="px-6 py-8 flex flex-col gap-6">
            {links.map(({ id, label, link }) => (
              <li key={id}>
                <Link
                  onClick={() => setNav(false)}
                  to={link}
                  smooth
                  duration={500}
                  offset={-80}
                  className="block cursor-pointer text-xl font-semibold text-gray-300 hover:text-cyan-300"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
